











































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import { AxiosVue } from '@/AxiosVue';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy, Accion } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue';
@Component({
  components: {
    ModalMantenedor,
    CabeceraModal,
    ContenidoModal,
  },
})
export default class CorregirCumplimientos extends Vue {
  @Prop({ required: true }) show: boolean;
  @Prop({ required: false, default: () => ({}) }) data: any;
  patente: string = '';
  cod_vehiculo: number = 0;
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  dato: string = '';
  cargarenvio() {
    this.axios.http
      .post('Metabase/PostgenericA/certificador_bhp/corregirEnvio', {
        cod_vehiculo: this.cod_vehiculo,
      })
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.dato = JSON.stringify(response.data.ult_json, null, 2);
          this.$nextTick(() => this.adjustTextareaHeight());
        } else {
          console.error(
            'Error al cargar los datos de la tabla:',
            response.data.MENSAJE_RESPUESTA
          );
        }
      })
      .catch((error: any) => {
        console.error('Error al realizar la petición:', error);
      })
      .finally(() => {});
  }

  adjustTextareaHeight() {
    const textareas = ['textarea', 'medidasTextarea'];
    textareas.forEach(ref => {
      const textarea = this.$refs[ref] as any;
      if (textarea && textarea.$el) {
        const el = textarea.$el.querySelector('textarea');
        if (el) {
          el.style.height = 'auto';
          el.style.height = `${el.scrollHeight}px`;
        }
      }
    });
  }

  @Watch('data', { immediate: true, deep: true })
  onDataChanged(newData: any) {
    if (newData) {
      this.patente = newData.patente_vehiculo;
      this.cod_vehiculo = newData.cod_vehiculo;
      this.cargarenvio();
    }
  }
  mounted() {
    this.adjustTextareaHeight();
  }

  updated() {
    this.adjustTextareaHeight();
  }
  handleCerrar() {
    this.$emit('update:value', false);
  }
  handleSubmit() {
    // Lógica para manejar el envío del formulario
    console.log('Datos enviados: ', {
      patente: this.patente,
      cod_vehiculo: this.cod_vehiculo,
    });
  }
}
